import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertComponent } from './shared/alert/alert.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { CredentialsService } from 'src/services/core/credentials/credentials.service';
import { Logger } from 'src/services/core/logger/logger.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, LoaderComponent, AlertComponent],
})
export class AppComponent implements OnInit {
  constructor(private credentialService: CredentialsService) {}

  isAuthenticated = () => this.credentialService.isAuthenticated();

  ngOnInit(): void {
    if (environment.production) {
      Logger.enableProductionMode();
    }
  }
}
